import React, { useState, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import debounce from 'utils/debounce';

import { Button, Textfield } from '../../components/base';
import Icon, { ICON_TYPE } from '../../components/base/icon';
import { Layout } from '../../components/rich';

const DraftSync = props => {
  const [name, setName] = useState(props.name);

  const changeNameRef = useRef();

  useEffect(() => {
    setName(props.name);
  }, [props.name]);

  const [label, color, buttonDisabled] = useMemo(() => {
    switch (props.state) {
      case 'changed':
        return ['Not saved', 'primary', false];

      case 'syncing':
        return ['Saving...', 'primary', true];

      case 'synced':
        return ['Saved', 'primary', false];

      case 'error':
        return ['Error Saving!', 'danger', false];

      default:
        return [null, 'primary', false];
    }
  }, [props.state]);

  const handleOnChange = e => {
    const value = e.target.value;
    setName(value);

    if (changeNameRef.current) {
      changeNameRef.current.cancel();
    }
    changeNameRef.current = debounce(() => {
      props.onNameChange(value);
    }, 500);
    changeNameRef.current();
  };

  const handleOnClick = e => {
    e.preventDefault();

    if (!buttonDisabled) {
      props.onNameChange(name);
      props.onSaveClick();
    }
  };

  return (
    <>
      <Layout.HeaderTitle
        color={color}
        style={{
          border: 0,
          fontWeight: 'normal',
          maxWidth: 200,
          whiteSpace: 'normal',
          textAlign: 'right',
        }}
      >
        {label}
      </Layout.HeaderTitle>
      <Textfield
        name="project_name"
        placeholder="Unnamed creation"
        value={name}
        onChange={handleOnChange}
        style={{ height: 'auto', lineHeight: 'initial' }}
      />
      <Button variant="secondary" onClick={handleOnClick} mr={[1, 1, 2]}>
        <Icon type={ICON_TYPE.SAVE} width={12} height={12} mr={1} />
        Save
      </Button>
    </>
  );
};

DraftSync.propTypes = {
  name: PropTypes.string,
  state: PropTypes.string,
  onNameChange: PropTypes.func,
  onSaveClick: PropTypes.func,
};

export default DraftSync;
